<div class="bg-white rounded-3xl shadow-(--shadow-input) p-4 text-center">
  <div class="w-full bg-(--bg-color) rounded-3xl p-4 flex flex-col items-center justify-center relative">

    <img src="assets/icons/file-upload.svg" alt="upload" class="w-8 h-8 mb-3" />

    <h3 class="text-generic mb-1">
      {{ title | translate}}
    </h3>

    <p class="text-(--text-primary) text-base mt-1">
      {{'SINGLE_FILE_UPLOAD.DRAG_DROP' | translate}}
    </p>
    <input #fileInput type="file" class="hidden" [accept]="acceptedTypes" (change)="onFileChange($event)"
      class="absolute top-0 bottom-0 right-0 left-0 opacity-0" />
  </div>

  <!-- Select file -->
  <button *ngIf="!selectedFile" type="button" class="click-text mt-5"
    (click)="triggerFileInput(fileInput)">{{'SINGLE_FILE_UPLOAD.SELECT_FILE' | translate}}</button>

  <!-- When file is selected -->
  <div *ngIf="selectedFile" class="items-center gap-4 justify-center mt-5 relative flex">
    <a [href]="selectedFile ? (selectedFile.name | lowercase) : ''" class="click-text truncate" target="_blank">
      {{ selectedFile.name }}
    </a>
    <button type="button" (click)="removeFile(); $event.stopPropagation()" title="Remove file"
      class="cursor-pointer hover:opacity-80 transition">
      <img src="assets/icons/bin.svg" alt="Bin icon" class="w-4 h-4" />
    </button>
  </div>
</div>

<!-- Validation error -->
<p *ngIf="control?.errors?.['maxSizeExceeded']" class="text-(--color-error) text-sm mt-2">
  {{ 'SINGLE_FILE_UPLOAD.FILE_SIZE_EXCEEDED' | translate:{ maxSizeMB: maxSizeMB } }}
</p>

<p class="text-(--text-muted) text-sm mt-2">
  {{ 'SINGLE_FILE_UPLOAD.FILE_ACCEPTS' | translate:{ acceptedTypes: acceptedTypes, maxSizeMB: maxSizeMB } }}
</p>